import { render, staticRenderFns } from "./reportFlagModal.vue?vue&type=template&id=ea581202&scoped=true&"
import script from "./reportFlagModal.vue?vue&type=script&lang=js&"
export * from "./reportFlagModal.vue?vue&type=script&lang=js&"
import style0 from "./reportFlagModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reportFlagModal.vue?vue&type=style&index=1&id=ea581202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea581202",
  null
  
)

export default component.exports